import { SiteDetailsSections } from "../add-element/collapsed/CollapsedSiteDetails";
import { ThemeIdentifier } from "../resources/modelTypes";
import SitePreviewContext from "../website/components/SitePreviewContext";
import { css } from "@emotion/react";
import { PillButton, IconEditSquare } from "@minted/minted-components";
import React, { memo, useContext } from "react";

type SectionId = number | SiteDetailsSections;

type EditButtonProps = {
  isClickable?: boolean;
  isMobile?: boolean;
  onClick?: (sectionId: SectionId) => void;
  sectionId: SectionId;
  themeIdentifier?: ThemeIdentifier;
};

const editButtonStyles = {
  wrapper: css`
    text-align: center;
  `,
};

const EditButton = ({
  isClickable = false,
  isMobile = false,
  onClick = () => {},
  sectionId,
  themeIdentifier,
}: EditButtonProps): React.ReactElement | null => {
  const { focusedClickSection, hoveredSection } =
    useContext(SitePreviewContext);

  const shouldDisplay =
    isClickable &&
    focusedClickSection?.id !== sectionId &&
    (hoveredSection?.id === sectionId || isMobile);

  if (shouldDisplay) {
    return (
      <div
        className={`editButtonWrapper ${themeIdentifier}`}
        css={editButtonStyles.wrapper}
      >
        <PillButton
          iconAlignment="right"
          icon={IconEditSquare}
          onClick={() => onClick(sectionId)}
          size="small"
        />
      </div>
    );
  }

  return null;
};

const MemoizedEditButton = memo(EditButton);

export { MemoizedEditButton as EditButton };

export default MemoizedEditButton;
